import React, { FC } from "react";
import rightImgPng from "images/our-features.png";
import NcImage from "shared/NcImage/NcImage";
import Badge from "shared/Badge/Badge";

export interface SectionOurFeaturesProps {
  className?: string;
  rightImg?: string;
  type?: "type1" | "type2";
}

const SectionOurFeatures: FC<SectionOurFeaturesProps> = ({
  className = "lg:py-14",
  rightImg = rightImgPng,
  type = "type1",
}) => {
  return (
    <div
      className={`nc-SectionOurFeatures relative flex flex-col items-center ${
        type === "type1" ? "lg:flex-row" : "lg:flex-row-reverse"
      } ${className}`}
      data-nc-id="SectionOurFeatures"
    >
      <div className="flex-grow">
        <NcImage src={rightImg} />
      </div>
      <div
        className={`max-w-2xl flex-shrink-0 mt-10 lg:mt-0 lg:w-2/5 ${
          type === "type1" ? "lg:pl-16" : "lg:pr-16"
        }`}
      >
        <span className="uppercase text-sm text-gray-400 tracking-widest">
          Benefiti saradnje sa nama
        </span>
        <h2 className="font-semibold text-4xl mt-5">
          Šta sve dobijaš saradnjom sa nama?
        </h2>

        <ul className="space-y-10 mt-16">
          <li className="space-y-4">
            <Badge name="Marketing" />
            <span className="block text-xl font-semibold">
              Dobijaš isplativo oglašavanje
            </span>
            <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
              Tvoj novać će biti uložen na pravi način, tako da će oglašavnje
              biti višestruko isplativo, a ne bacanje novca.
            </span>
          </li>
          <li className="space-y-4">
            <Badge color="green" name="Optimizacija " />
            <span className="block text-xl font-semibold">
              Google će postati tvoj prijatelj
            </span>
            <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
              Milioni ljudi svakog dana pretražuju različite upite, učinićemo da
              se baš tvoj sajt pojavi u Google pretrazi.
            </span>
          </li>
          <li className="space-y-4">
            <Badge color="red" name="Efikasnost" />
            <span className="block text-xl font-semibold">Brzo i efikasno</span>
            <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
              Adjustment DIgital tim se trudi da u što kraćem roku dostavi plan
              rada i realizuje zacrtane ciljeve
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SectionOurFeatures;